import { Routes } from '@angular/router';

/**
 * The candidate routes (docs/10 4a-4d + the transparency page): the list, the position detail
 * with the apply form, the signed-link application view, and "Hvad AI ser". All lazy-loaded;
 * titles are Danish defaults (the surface language switches at runtime, the document title
 * follows the route entry point).
 */
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/positions/positions-page').then((m) => m.PositionsPage),
    title: 'Ledige stillinger',
  },
  {
    path: 'stillinger/:slug',
    loadComponent: () => import('./pages/position/position-page').then((m) => m.PositionPage),
    title: 'Ledige stillinger',
  },
  {
    path: 'min-ansoegning/:token',
    loadComponent: () =>
      import('./pages/application/application-page').then((m) => m.ApplicationPage),
    title: 'Min ansøgning',
  },
  {
    path: 'hvad-ai-ser',
    loadComponent: () =>
      import('./pages/what-ai-sees/what-ai-sees-page').then((m) => m.WhatAiSeesPage),
    title: 'Hvad AI ser',
  },
  { path: '**', redirectTo: '' },
];
